export const DEFAULT_FILL_COLOR = [190, 190, 190, 200];
export const DEFAULT_LINE_COLOR = [80, 80, 80];
const DEFAULT_FILL_OPACITY = 0.15;

export const overlayCategories = [
  { id: "climate-weather", label: "Climate and Weather" },
  { id: "administrative-boundaries", label: "Administrative Boundaries" },
];

export const initialOverlayState = {
  "weather-radar": {
    id: "weather-radar",
    name: "Weather Radar",
    category: "climate-weather",
    active: false,
    layerType: "WMSOverlay",
    urlParams: {
      SERVICE: "WMS",
      VERSION: "1.1.1",
      REQUEST: "GetMap",
      SRS: "EPSG:3857",
      FORMAT: "image/png",
      TRANSPARENT: "true",
      BBOX: "{east},{north},{west},{south}",
      LAYERS: "{layers}",
      HEIGHT: "{height}",
      WIDTH: "{width}",
    },
    label: "Radar Loop",
    description:
      "The Weather radar base reflectivity mosaics are created using data from U.S. Weather Surveillance Radar 1988 Doppler (WSR-88D) sites operated by NWS and DOD and also from the Canadian Environment and Climate Change (ECCC) network of S-band dual polarization radars. The horizontal resolution is 1 km (0.62 mi). The mosaics are updated approximately every 2 minutes. The colors on the map represent the strength of the energy reflected back toward the radar and are given in dBZ (decibels of z). Data source: NWS & OAR Multi-Radar/Multi-Sensor (MRMS) System.",
    serviceType: "wms",
    serverType: "geoserver",
    opacity: DEFAULT_FILL_OPACITY,
    overlayType: "WMSOverlay",
    baseUrl: `https://nowcoast.noaa.gov/geoserver/`,
    workspaceId: "weather_radar",
    layerId: "base_reflectivity_mosaic",
    layerOptions: [
      {
        label: "Radar Base Reflectivity Mosaic",
        layerId: "base_reflectivity_mosaic",
        workspaceId: "weather_radar",
        legendConfig: {
          label: "Weather Radar Base Reflectivity",
          url: "https://nowcoast.noaa.gov/geoserver/observations/weather_radar/ows?service=WMS&version=1.3.0&request=GetLegendGraphic&format=image%2Fpng&width=272&height=21&layer=conus_base_reflectivity_mosaic",
        },
      },
    ],
    queryParams: {
      SERVICE: "WMS",
      VERSION: "1.1.1",
      REQUEST: "GetMap",
      SRS: "EPSG:3857",
      FORMAT: "image/png",
      TRANSPARENT: "true",
      BBOX: "{east},{north},{west},{south}",
      LAYERS: "{layers}",
      HEIGHT: "{height}",
      WIDTH: "{width}",
    },
    animated: true,
    dateTimes: null,
  },
  drought: {
    id: "drought",
    active: false,
    category: "climate-weather",
    name: "Drought",
    layerType: "GeoJsonLayer",
    description:
      "Reported conditions are updated weekly and are based on a composite index that includes many indicators. The U.S. Drought Monitor is jointly produced by the National Drought Mitigation Center at the University of Nebraska-Lincoln, the United States Department of Agriculture, and the National Oceanic and Atmospheric Administration. Map courtesy of NDMC-UNL.",
    baseUrl:
      "https://services5.arcgis.com/0OTVzJS4K09zlixn/ArcGIS/rest/services/USDM_current/FeatureServer/0/query?f=geojson&geometryPrecision=4&maxAllowableOffset=&orderByFields=DM&outFields=DM,ReleaseDate&outSR=4236&returnGeometry=true&where=1%3D1",
    urlParams: "",
    layerConfig: {
      filled: true,
      getLineWidth: 0,
      lineWidthMinPixels: 0,
      lineWidthUnits: "pixels",
      pickable: false,
    },
    fillColorProperty: "DM",
    fillColorMap: [
      {
        value: 0,
        label: "Abnormally Dry",
        color: [255, 255, 0],
        match: "exact",
      },
      {
        value: 1,
        label: "Moderate Drought",
        color: [252, 211, 127],
        match: "exact",
      },
      {
        value: 2,
        label: "Severe Drought",
        color: [255, 170, 0],
        match: "exact",
      },
      {
        value: 3,
        label: "Extreme Drought",
        color: [230, 0, 0],
        match: "exact",
      },
      {
        value: 4,
        label: "Exceptional Drought",
        color: [115, 0, 0],
        match: "exact",
      },
    ],
    legendConfig: {
      legendType: "static-categorical",
      legendValues: [
        { value: "None", description: "", hex: "#fff" },
        { value: "D0", description: "Abnormally Dry", hex: "#FFFF00" },
        { value: "D1", description: "Moderate Drought", hex: "#FCD37F" },
        { value: "D2", description: "Severe Drought", hex: "#FFAA00" },
        { value: "D3", description: "Extreme Drought", hex: "#E60000" },
        { value: "D4", description: "Exceptional Drought", hex: "#730000" },
      ],
      comment: "",
    },
  },
  hurricane: {
    name: "Hurricanes",
    category: "climate-weather",
    active: false,
    layerType: "TileLayer",
    serviceBaseUrl:
      "https://mapservices.weather.noaa.gov/tropical/rest/services/tropical/NHC_tropical_weather_summary/MapServer",
    baseUrl:
      "https://mapservices.weather.noaa.gov/tropical/rest/services/tropical/NHC_tropical_weather_summary/MapServer/export",
    urlParams:
      "?transparent=true&format=png8&layers=show:3,4,6,7,8,11&bboxSR=4326&imageSR=3857&size=1024,1024&f=image",
    legendConfig: {
      legendType: "arcGis",
      legendUrl:
        "https://idpgis.ncep.noaa.gov/arcgis/rest/services/NWS_Forecasts_Guidance_Warnings/NHC_tropical_weather_summary/MapServer/legend?f=pjson",
      arcGisLayers: [3, 4, 6, 7, 8, 11],
      comment: "",
      dataSource: {
        url: "https://www.nhc.noaa.gov/",
        label:
          "National Oceanic and Atmospheric Administration (NOAA) - National Hurricane Center ",
      },
    },
  },
  // "wildfire-boundary": {
  //   name: "Wildfire Boundaries",
  //   category: "climate-weather",
  //   active: false,
  //   layerType: "GeoJsonLayer",
  //   baseUrl:
  //     "https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services/Current_WildlandFire_Perimeters/FeatureServer/0/query?where=1%3D1&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=*&returnGeometry=true&returnCentroid=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pgeojson&token=",
  //   layerConfig: {
  //     filled: false,
  //     // getFillColor: [160, 160, 180, 200],
  //     getLineColor: [255, 50, 50, 255],
  //     getLineWidth: 3,
  //     lineWidthMinPixels: 3,
  //     lineWidthUnits: "pixels",
  //     pickable: false,
  //     getDashArray: [3, 2],
  //     dashJustified: true,
  //     dashGapPickable: false,
  //     lineCapRounded: true,
  //     lineJointRounded: true,
  //   },
  //   pathExtension: true,
  // },
  // "usbr-office-boundary": {
  //   name: "USBR Area Office Boundaries",
  //   category: "administrative-boundaries",
  //   active: false,
  //   layerType: "GeoJsonLayer",
  //   baseUrl:
  //     "https://services1.arcgis.com/ixD30sld6F8MQ7V5/ArcGIS/rest/services/AreaBoundaries/FeatureServer/0/query?where=1%3D1&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=*&returnGeometry=true&returnCentroid=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pgeojson&token=",
  //   layerConfig: {
  //     filled: true,
  //     getFillColor: [190, 190, 190, 200],
  //     getLineColor: [160, 160, 180, 255],
  //     getLineWidth: 3,
  //     lineWidthUnits: "pixels",
  //     lineWidthMinPixels: 2,
  //     lineCapRounded: true,
  //     lineJointRounded: true,
  //     pickable: false,
  //   },
  //   pathExtension: false,
  // },
  // "usbr-regional-boundary": {
  //   name: "USBR Regional Boundaries",
  //   category: "administrative-boundaries",
  //   active: false,
  //   layerType: "GeoJsonLayer",
  //   baseUrl:
  //     "https://services1.arcgis.com/ixD30sld6F8MQ7V5/ArcGIS/rest/services/ReclamationBoundariesFL/FeatureServer/0/query?where=1%3D1&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=*&returnGeometry=true&returnCentroid=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pgeojson&token=",
  //   layerConfig: {
  //     filled: true,
  //     getFillColor: [190, 190, 190, 200],
  //     getLineColor: [160, 160, 180, 255],
  //     getLineWidth: 3,
  //     lineWidthUnits: "pixels",
  //     lineWidthMinPixels: 2,
  //     lineCapRounded: true,
  //     lineJointRounded: true,
  //     pickable: false,
  //   },
  //   pathExtension: false,
  // },
  "noaa-climate-zones": {
    name: "NOAA Climate Zones",
    category: "administrative-boundaries",
    active: false,
    layerType: "GeoJsonLayer",
    baseUrl:
      "https://nwdi-app-data.s3.us-west-2.amazonaws.com/overlays/noaa_clim_zones.geojson.gz",
    layerConfig: {
      filled: true,
      getLineColor: [160, 160, 180, 255],
      getLineWidth: 2,
      lineWidthUnits: "meters",
      lineWidthMinPixels: 2,
      lineWidthScale: 2,
      lineCapRounded: true,
      lineJointRounded: true,
      pickable: false,
    },
    fillColorProperty: "WELL",
    fillColorMap: {
      Y: [190, 190, 190, 200],
      N: [0, 0, 0, 0],
    },
  },
};
